import { ArrowDropDown } from '@mui/icons-material';
import { Box, ButtonGroup as MUIButtonGroup, Stack, SxProps, TextField, Theme, Typography, useTheme } from '@mui/material';
import { Button } from '../Button/Button'
import { Menu } from '../Menu/Menu';
import { PWMenuItem } from '../Menu/MenuItem';
import merge from 'lodash.merge';
import { useState, useRef, useEffect } from 'react';

interface ButtonGroupProps {
    defaultOption: { value: string; label: string };
    options: { value: string; label: string }[];
    disabled?: boolean;
    sx?: {
        container?: SxProps<Theme>;
        buttonGroup?: SxProps<Theme>;
        leftButton?: SxProps<Theme>;
        rightButton?: SxProps<Theme>;
        menu?: SxProps<Theme>;
        text?: SxProps<Theme>;
    };
    leftButtonChildren?: React.ReactNode;
    onButtonClick?: (value: string | undefined) => void;
    onChange?: (value: string) => void;
}

const useButtonGroupStyles = (theme: Theme): { [key: string]: React.CSSProperties | Object } => ({
    buttonGroup: {
       
    },
    leftButton: {
        flexGrow: 1,
        gap: 1,
        '&:focus': {
            boxShadow: 'none'
        },
        '&:focus-visible': {
            boxShadow: 'none'
        },
        '&.MuiButtonGroup-firstButton': {
            borderColor: theme.palette.action.inactive,
        },
        '&.MuiButtonGroup-firstButton:hover':{
            color: theme.palette.text.primary,
            border: '1px solid'
        }
    },
    rightButton: {
        padding: 0,
        '&:focus': {
            boxShadow: 'none'
        },
        '&:focus-visible': {
            boxShadow: 'none'
        },
        '&.MuiButtonGroup-lastButton':{
            borderColor: theme.palette.action.inactive,
        },
        '&.MuiButtonGroup-lastButton:hover':{
            color: theme.palette.text.primary,
            border: '1px solid'
        }
    },
    text: { fontSize: '18px' },
    option: { margin: 0, padding: '0 8px', width: '100%', justifyContent: 'start' },
    divider: { width: '100%', marginBottom: '4px' }
});

export const ButtonGroup = (props: ButtonGroupProps) => {
    const theme = useTheme();
    const styles = useButtonGroupStyles(theme);

    const {
        defaultOption,
        options,
        disabled,
        sx,
        leftButtonChildren,
        onButtonClick,
    } = props;
    
    const [showSubMenu, setShowSubMenu] = useState(false);
    const buttonRef = useRef<HTMLDivElement | null>(null);

    const handleViewClick = (event: any) => {
        setShowSubMenu(!showSubMenu);
    };
    const handleSelectionClick = (value: string | undefined) => {
        onButtonClick?.(value);
        setShowSubMenu(false);
    };
    
    const handleClose = (event: any) => {
        setShowSubMenu(false);
    }

    return (
        <Stack sx={sx?.container}>
            <MUIButtonGroup
                disableElevation
                variant="contained"
                disabled={disabled}
                sx={merge(styles.buttonGroup, sx?.buttonGroup)}
                ref={buttonRef}
                aria-label={`${defaultOption.label} ButtonGroup`}>
                <Button
                    type='clear'
                    sx={{
                        clear: merge(styles.leftButton, sx?.leftButton)
                    }}
                    onClick={() => onButtonClick?.(defaultOption.value) }>
                    {leftButtonChildren}
                   
                    <Typography>
                        { defaultOption.label }
                    </Typography>
                </Button>
                <Button
                    type='clear'
                    aria-controls={showSubMenu ? 'split-button-menu' : undefined}
                    aria-expanded={showSubMenu ? 'true' : undefined}
                    aria-haspopup="menu"
                    sx={{
                        clear: merge(styles.rightButton, sx?.rightButton)
                    }}
                    onClick={handleViewClick}
                   >
                    <ArrowDropDown fontSize="small" />
                </Button>
            </MUIButtonGroup>

            {showSubMenu && (
                <Menu anchorEl={buttonRef.current} open={showSubMenu} onClose={() => setShowSubMenu(false) }>
                    {options?.map(
                        (option:any, index:number)=> 
                            <PWMenuItem id={index.toString()} key={index} value={option.value} onClick={() => handleSelectionClick(option.value) }>
                                {option.label}
                            </PWMenuItem>
                    )}
                </Menu>
            )}
        </Stack>
    );
};
